import { ClientError } from '~/lib/error/clientError'
import type { HtmlFragment } from '~/lib/graphql/scalars'

export class RecoverableClientError extends ClientError {
  static fromString(message: string): RecoverableClientError {
    return new RecoverableClientError({ type: 'string', message: message })
  }

  static fromHtmlFragments(fragments: HtmlFragment[]): RecoverableClientError {
    return new RecoverableClientError({ type: 'html', fragments: fragments })
  }
}
